<template>
  <div>
    <div class="partners-banner">
      <img src="@/assets/images/website/partners/about-img.jpg" />
      <div>
        <h3>合作伙伴</h3>
        <p>中色云通过合作实现各方价值最大化，共建工业互联网新生态！</p>
      </div>
    </div>
    <div class="partners-common">
      <div class="title">合作伙伴 · 企业</div>
      <div class="wrap">
        <div class="companyItem" v-for="item in companyList" :key="item">
          <img :src="item.url" />
        </div>
      </div>
    </div>
    <div class="partners-common partners-university">
      <div class="title">合作伙伴 · 高校</div>
      <div class="wrap">
        <div class="universityItem" v-for="item in universityList" :key="item">
          <img :src="item.url" />
        </div>
      </div>
    </div>
    <div class="partners-common">
      <div class="title">合作伙伴 · 企业</div>
      <div class="wrap">
        <div class="enterpriseItem" v-for="item in enterpriseList" :key="item">
          <img :src="item.url" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companyList: [
        { url: require("@/assets/images/website/partners/logo1.jpg") },
        { url: require("@/assets/images/website/partners/logo2.jpg") },
        { url: require("@/assets/images/website/partners/logo3.jpg") },
        { url: require("@/assets/images/website/partners/logo4.jpg") },
        { url: require("@/assets/images/website/partners/logo5.jpg") },
        { url: require("@/assets/images/website/partners/logo6.jpg") },
        { url: require("@/assets/images/website/partners/logo7.jpg") },
        { url: require("@/assets/images/website/partners/logo8.jpg") },
        { url: require("@/assets/images/website/partners/logo9.jpg") },
        { url: require("@/assets/images/website/partners/logo10.jpg") },
        { url: require("@/assets/images/website/partners/logo11.jpg") },
        { url: require("@/assets/images/website/partners/logo12.jpg") },
        { url: require("@/assets/images/website/partners/logo13.jpg") },
        { url: require("@/assets/images/website/partners/logo14.jpg") },
        { url: require("@/assets/images/website/partners/logo15.jpg") },
        { url: require("@/assets/images/website/partners/logo16.jpg") },
        { url: require("@/assets/images/website/partners/logo17.jpg") },
        { url: require("@/assets/images/website/partners/logo18.jpg") },
        { url: require("@/assets/images/website/partners/logo19.jpg") },
        { url: require("@/assets/images/website/partners/logo20.jpg") },
      ],
      universityList: [
        { url: require("@/assets/images/website/partners/logox1.jpg") },
        { url: require("@/assets/images/website/partners/logox2.jpg") },
        { url: require("@/assets/images/website/partners/logox3.jpg") }
      ],
      enterpriseList: [
        { url: require("@/assets/images/website/partners/logoq1.jpg") },
        { url: require("@/assets/images/website/partners/logoq2.jpg") },
        { url: require("@/assets/images/website/partners/logoq3.jpg") },
        { url: require("@/assets/images/website/partners/logoq4.jpg") },
        { url: require("@/assets/images/website/partners/logoq5.jpg") },
        { url: require("@/assets/images/website/partners/logoq6.jpg") },
        { url: require("@/assets/images/website/partners/logoq7.jpg") },
        { url: require("@/assets/images/website/partners/logoq8.jpg") }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.partners-banner {
  width: 100%;
  height: 412px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  div {
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 142px;
    padding-left: 345px;

    h3 {
      font-family: PingFangSC-Medium;
      font-size: 54px;
      color: #293341;
      font-weight: 500;
      margin-bottom: 5px;
    }

    p {
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #293341;
      font-weight: 400;
    }
  }
}

.partners-university {
  background: #F2F6FA;
}

.partners-common {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0px 20px;

  .title {
    font-family: PingFangSC-Regular;
    font-size: 36px;
    color: #2A313B;
    letter-spacing: 0;
    text-align: center;
    line-height: 36px;
    font-weight: 400;
    margin-bottom: 63px;
  }

  .wrap {
    width: 1280px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .companyItem {
      width: 305px;
      height: 100px;
      margin-bottom: 20px;
      background: #FFFFFF;
      box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 74px;
      }
    }

    .universityItem {
      width: 413px;
      height: 135px;
      background: #FFFFFF;
      box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 74px;
      }
    }

    .enterpriseItem {
      width: 305px;
      height: 100px;
      margin-bottom: 20px;
      background: #FFFFFF;
      box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 74px;
      }
    }
  }
}
</style>